import type { ComponentSpec } from "../Processing/types";
import { getWidgetDef } from "../widgetRegistry";
import { NoDuplication } from "../widgetContract";
import type { DuplicationHandler } from "../widgetContract";

/**
 * Regenerate a (cloned) widget spec's queryIds + cross-references so a duplicated or
 * imported widget gets independent data identities. The per-widget logic lives in
 * `Duplication/<type>.ts` and is wired onto each definition's `duplicate` field; this
 * just dispatches to it. Widgets with no queryIds declare `NoDuplication`.
 */
export function remapSpecQueryIds(spec: ComponentSpec): void {
  const dup = getWidgetDef(spec.type)?.duplicate;
  if (dup && dup !== NoDuplication) {
    (dup as DuplicationHandler)(spec);
  }
}
